var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35,12.76l1.45,4.47-3.8-2.76-3.8,2.76,1.45-4.47-3.8-2.76h4.7l1.45-4.47,1.45,4.47h4.7l-3.8,2.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/1762842647/media/icon-star.1ab554377aa7f85f04ce3ee051a346de.svg";
export { ForwardRef as ReactComponent };